import React from "react";
import type { IHoliday } from "App/Modules/Models";
import { useTranslation } from "react-i18next";

import "./_partner-details.scss";

type InjectedProps = {
    holidays: IHoliday[];
    presence: "ongoing" | "future" | "past";
};

type HolidayListProps = InjectedProps;

export const HolidaysList = (props: HolidayListProps) => {
    const { t } = useTranslation();
    const { holidays, presence } = props;
    let modifier = "";
    switch (presence) {
        case "ongoing":
            modifier = "caption--bold";
            break;
        case "past":
            modifier = "caption--italic";
            break;
        case "future":
        default:
            // no changes
            modifier = "";
    }
    return holidays.length > 0 ? (
        <div className="data-panels data-panels--rows">
            {holidays.map((h) => {
                let date = "";
                if (h.dtStop.diff(h.dtStart, "hours") === 0) {
                    date = h.dtStart.format("L");
                } else {
                    date = `${h.dtStart.format("L")} - ${h.dtStop.format("L")}`;
                }
                return (
                    <div className="data-panels__panel" key={h.id}>
                        <div className="data-panels__heading">
                            <p className={`caption ${modifier}`}>{h.name}</p>
                        </div>
                        <div className="data-panels__value">
                            <p className={`caption ${modifier}`}>{date}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    ) : (
        <div>
            <p className="caption caption--italic">{t("Entities.Schedule.HolidaysNone")}</p>
        </div>
    );
};
